import React, { useEffect, useState } from 'react';
import { Modal, notification } from 'antd';
import { useFormik } from 'formik';
import * as yup from 'yup';
import axiosInstance from '../../../../Services/axiosCommon';
import { NuInput } from '../../../../Components/Utils/Input';
import { useToast } from '../../../../Components/Others/ToastServices';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';

const EditEquipmentEqu = ({ open, getData = () => {}, onCancel, data, id }) => {
  const [api, contextHolder] = notification.useNotification();
  const toast = useToast();

  const [selectedFile, setSelectedFile] = useState(null);
  const [filePathList, setFilePathList] = useState([]);
  const [fileRemoveList, setFileRemoveList] = useState([]);
  const [image, setImage] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [fileExtention, setFileExtention] = useState("");

  const { value: type } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "type_equipments"
  );

  const [initialData, setInitialData] = useState({
    idNumber: "",
    type: "",
    location: "",
    qrCode: ""
  });

  useEffect(() => {
    if (data) {
      setInitialData({
        idNumber: data.idNumber || "",
        type: data.type || "",
        location: data.location || "",
        qrCode: data.qrCode || ""
      });
    }
  }, [data]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialData,
    validationSchema: yup.object({
      idNumber: yup.string().required("ID Number is required"),
      type: yup.string().required("Type is required"),
      location: yup.string().required("Location is required"),
      qrCode: yup.string().required("QR Code is required")
    }),
    onSubmit: (value, { resetForm }) => {

      // let formData = new FormData();
      // const valueWithFiles = {
      //   ...value,
      //   filesToRemove: fileRemoveList
      // };
      // formData.append("json_data", JSON.stringify(valueWithFiles));

      // if (selectedFile !== null) {
      //   selectedFile.forEach((file) => {
      //     formData.append("attachments", file);
      //   });
      // } else {
      //   formData.append("attachments", []);
      // }
      axiosInstance
        .put(`/equipment-details/update/${data?.id}`, value)
        .then((res) => {
          if (res.data.status) {
            api.success({
              message: `Equipment updated successfully`,
              description: res?.data?.msg || "Updated equipment",
              placement: "bottomRight",
            });
            getData(id);
            resetForm();
            onCancel();
          } else {
            api.error({
              message: `Update failed`,
              description: res?.data?.msg || "Network error",
              placement: "bottomRight",
            });
          }
        })
        .catch((err) => {
          api.error({
            message: `Update failed`,
            description: err?.response?.data?.msg || "Server error",
            placement: "bottomRight",
          });
        });
    }
  });

  function handleImageChange(e) {
    const maxFileSize = 200000000;
    const files = Array.from(e.target.files);
    let fileArr = [];
    let tempArr = [];

    files.forEach((item) => {
      if (item.size < maxFileSize) {
        fileArr.push(item);
        tempArr.push(item?.name);
      } else {
        toast.open({
          type: "warning",
          message: `File too big`,
          description: `${item.name} was removed and not uploaded`,
        });
      }
    });

    setSelectedFile(fileArr);
    setImage(tempArr);
  }

  function UpdateAttachmentList(file) {
    let filtered = filePathList.filter((f) => f.file !== file);
    let removed = filePathList.find((f) => f.file === file);
    setFileRemoveList([...fileRemoveList, removed.file]);
    setFilePathList(filtered);
  }

  function handleImageClick(img) {
    let Ext = img?.file_name.split(".").reverse()[0];
    setSelectedImage(img);
    setFileExtention(Ext);
  }

  return (
    <>
      {contextHolder}
      <Modal
        open={open}
        title="Edit Equipment"
        width="75%" // ✅ mobile-friendly (auto resizes)
        className="perfect-centered-modal"
        centered
        onCancel={onCancel}
        footer={null}
        styles={{
          body: { maxHeight: '70vh', overflowY: 'auto', padding: '8px' }
        }}
        responsive
      >
        <form onSubmit={formik.handleSubmit} className="w-full">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Left side */}
            <NuInput
              label="ID Number"
              name="idNumber"
              formik={formik}
              placeholder="Enter ID"
              width="w-full"
            />

            <FormikSelectTwo
              label="Type"
              Options={type}
              formik={formik}
              placeholder="Choose"
              name="type"
              width="w-full"
            />

            <NuInput
              label="Location"
              name="location"
              formik={formik}
              placeholder="Enter location"
              width="w-full"
            />

            <NuInput
              label="QR Code"
              name="qrCode"
              formik={formik}
              placeholder="Enter QR code"
              width="w-full"
            />
              {/* <div className="w-full">
              <SettingHeading title="Attachments :" />
            </div>

            <div className="flex flex-wrap gap-2 w-full">
              {filePathList?.map((imgs, idx) => {
                let Ext = imgs?.file_name.split(".").reverse()[0];
                return (
                  <div
                    key={idx}
                    className="w-20 h-9 my-2 relative flex justify-center items-center rounded-lg border border-slate-400"
                  >
                    <div
                      className="w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer flex justify-center items-center -top-2 -right-2"
                      onClick={() => UpdateAttachmentList(imgs?.file)}
                    >
                      <CloseIcon color="white" height="8" width="8" />
                    </div>
                    <div
                      className="w-20 h-9 flex justify-center items-center cursor-pointer overflow-hidden"
                      onClick={() => handleImageClick(imgs)}
                    >
                      <div className="w-8 h-8">
                        {videotype.includes(Ext) ? <Video /> :
                          Ext === "docx" || Ext === "doc" ? <Doc /> :
                          Ext === "xlsx" || Ext === "xls" ? <Xls /> :
                          Ext === "txt" ? <Txt /> :
                          Ext === "pdf" || Ext === "PDF" ? <Pdf /> :
                          <img src={imgs?.file} alt="#" width="120%" />}
                      </div>
                      <p className="w-[50px] text-[11px] truncate">{imgs?.file_name}</p>
                    </div>
                  </div>
                );
              })}

              <Attachement
                handleChange={handleImageChange}
                preview={image || ""}
                width="w-full md:w-1/2"
                label="Attach"
                multiple={true}
              />
            </div> */}
          </div>

          {/* Submit Button */}
          <div className="flex justify-center mt-6">
            <button
              type="submit"
              className="w-full md:w-1/2 bg-baseColor-primary py-3 rounded-lg text-sm text-white transition hover:opacity-90"
            >
              Update
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default EditEquipmentEqu;
